<template>
  <label class="block py-4 overflow-hidden relative" v-bind="$attrs">
    <div
      class="
        mui-textfield
        mui-textfield--float-label
        mui-textfield--no-underline
        mui-textfield--inherit-color
        mui-textfield--reduced-range
        mui-textfield--programmatic
        mui-textfield--label-medium
        pl-8 lg:pl-4 2xl:pl-8
        pr-10 lg:pr-8 2xl:pr-10
        m-0
      "
      :class="{'mui-textfield--label-gray': grayLabel}"
    >
      <input
        :name="name"
        :value="value"
        :readonly="readonly"
        ref="input"
        @focus="handleFocus"
        class="overflow-ellipsis font-[500]"
        :class="{'pointer-events-none': readonly}"
        @input="handleInput"
      />
      <label v-text="label"></label>
    </div>
    <div
      class="
        absolute
        right-4 lg:right-2 2xl:right-4
        bottom-[1.125rem]
        transition-transform
        duration-300
      "
      :class="{ '-scale-y-100': isOpened, '-translate-y-2': !value }"
    >
      <svg width="24" height="24">
        <use xlink:href="#chevron-24x24-down" />
      </svg>
    </div>
  </label>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'SearchFormInput',
  props: {
    label: String,
    name: String,
    value: String,
    isOpened: Boolean,
    readonly: Boolean,
    grayLabel: {
      type: Boolean,
      default: true,
    }
  },
  watch: {
    value() {
      const { input } = this.$refs
      Vue.nextTick(() => {
        input.dispatchEvent(new Event('input'))
      })
    },
  },
  methods: {
    handleFocus() {
      this.$emit('openstatechange', true)
    },
    handleInput(e) {
      this.$emit('input', e.target.value)
    },
  },
}
</script>
